import React from "react"

import BackgroundMore from "../BackgroundMore"

import { Wrapper, Content, Text, Title, Subtitle, Image } from "./styled"

const HeroHome = () => {
  return (
    <Wrapper>
      <Content>
        <Image>
          <BackgroundMore />
        </Image>
        <Text>
          <Title>React, NodeJS, Typescript e muito mais</Title>
          <Subtitle>
            Tenha acesso à conteúdos sobre as tecnologias mais utilizadas no
            mercado
          </Subtitle>
        </Text>
      </Content>
    </Wrapper>
  )
}

export default HeroHome
